<template>
  <el-dialog class="address-edit-modal"
             width="390px"
             :title="model.id ? '编辑收货地址' : '新增收货地址'"
             :visible.sync="visible"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
  >
    <form @submit.prevent="save" v-loading="loading">
      <div class="field">
        <div class="label">联系人</div>
        <div class="cont">
          <el-input :maxlength="20" size="small" v-model="model.name"></el-input>
        </div>
      </div>
      <div class="field">
        <div class="label">手机号</div>
        <div class="cont">
          <el-input :maxlength="20" size="small" input-type="phone" v-model="model.phone"
                    @input="phoneNumberChange"
          ></el-input>
        </div>
      </div>
      <div class="field">
        <div class="label">所在地区</div>
        <div class="cont">
          <address-selector placeholder="请选择地区" :source-object="model"></address-selector>
        </div>
      </div>
      <div class="field">
        <div class="label">详细地址</div>
        <div class="cont">
          <el-input :maxlength="200" type="textarea" size="small" v-model="model.details"></el-input>
        </div>
      </div>
      <div class="field" style="margin:-15px 0 0 0;padding: 4px 0;">
        <div class="label"></div>
        <div class="cont">
          <el-checkbox v-model="model.isdefault">设为默认地址</el-checkbox>
        </div>
      </div>
      <div class="field">
        <div class="label"></div>
        <div class="cont actions">
          <el-button size="small" @click="close">取消</el-button>
          <el-button type="primary" size="small" native-type="submit">保存</el-button>
        </div>
      </div>
    </form>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import ModalMixin from '@/mixins/modal/modal-mixin'
import AddressSelector from '@/components/AddressSelector'
import { AddAddress } from '../services'
export default {
  components: { AddressSelector },
  mixins: [ModalMixin],
  data () {
    return {
      isdefault: false,
      model: {},
      user: {},
      loading: false
    }
  },
  methods: {
    init (addressInfo, user) {
      if (addressInfo && addressInfo.isdefault) {
        this.isdefault = true
      }
      this.user = user || {}
      this.model = addressInfo ? _.cloneDeep(addressInfo) : {}
      return this.open()
    },
    checkFields () {
      if (!this.model.name) {
        return '请输入联系人'
      }
      if (!this.model.phone) {
        return '请输入联系电话'
      }
      if (this.model.phone.length !== 11) {
        return '请输入正确的联系电话'
      }
      if (!this.model.province || !this.model.city || !this.model.area) {
        return '请选择地区'
      }
      if (!this.model.details) {
        return '请输入详细地址'
      }
      return null
    },
    save () {
      let err = this.checkFields()
      if (err) {
        this.$message.error(err)
        return
      }
      this.loading = true
      this.model.isdefault = !!this.model.isdefault
      delete this.model.update_time
      AddAddress(
        {
          ...this.model,
          companyId: (this.user && this.user.companyId) || undefined
        }).then(() => {
        this.$message.success(`收货地址保存成功`)
        this.close(true)
      }).finally(() => {
        this.loading = false
      })
    },
    phoneNumberChange () {
      if (this.model.phone.length > 11) {
        this.model.phone = this.model.phone.slice(0, 11)
      }
    }
  }
}
</script>
